import { render, staticRenderFns } from "./AssignTravelPolicy.vue?vue&type=template&id=3e35a963&"
import script from "./AssignTravelPolicy.vue?vue&type=script&lang=js&"
export * from "./AssignTravelPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports